<template>
<div class="swaychat-modal">
  <transcript-form v-if="showForm" @close="showForm = false"></transcript-form>
  <div class="swaychat-modal-content swaychat-fadeInUp" v-show="!showForm">
    <button class="swaychat-modal-close swaychat-button-close" @click="cancel">×</button>
    <div class="swaychat-rate-wrapper">
      <div class="swaychat-rate">
        <div class="swaychat-bounceIn" :class="{
          'swaychat-rate-great': getSession.rate == 2 || !getSession.rate,
          'swaychat-rate-ok': getSession.rate == 1,
          'swaychat-rate-notgood': getSession.rate == -1
          }"><i class="swaychat-rate-icon swaychat-rate-icon-large"></i></div>
        <h5 class="swaychat-rate-success-label"><span>{{ rating }}</span></h5>
        <h5 class="swaychat-rate-success-label" v-if="getSession.rate && getSession.rate !== 2"><span>{{ getLang.sorry }}</span></h5>
        <hr>
        <button-form-component @click="newChat" expand="true" primary="true" :label="loading ? getLang.please_wait : getLang.start_new_chat"></button-form-component>
        <button-form-component @click="showForm = true" expand="true" outline="true" :label="getLang.email_transcript" v-if="getSettings.transcript" v-show="!loading"></button-form-component>
        <button-form-component @click="cancel" expand="true" outline="true" :label="getLang.cancel" v-show="!loading"></button-form-component>
      </div>
    </div>
  </div>
  <powered-by-component></powered-by-component>
</div>
</template>

<script>

import {
  mapGetters
} from 'vuex'
import ButtonFormComponent from './input/ButtonFormComponent.vue'
import TranscriptForm from './TranscriptForm.vue'
import PoweredByComponent from './PoweredByComponent.vue'
import Raven from 'raven-js'

export default {
  components: {
    ButtonFormComponent,
    TranscriptForm,
    PoweredByComponent
  },
  data() {
    return {
      showForm: false,
      loading: false,
    }
  },
  computed: {
    rating() {
      let r = ''

      if (this.getSession.rate && this.getLang.rated)
        r = this.getLang.rated.replace('{rating}', this.getLang.ratings[this.getSession.rate].label)
      else
        r = this.getLang.thank_you

      return r
    },
    ...mapGetters([
      'getLang',
      'getSession',
      'getSettings'
    ])
  },
  methods: {
    cancel() {
      this.$store.dispatch('cancelEnd')
    },
    newChat() {
      if (this.loading)
        return

      this.loading = true
      this.$store.dispatch('requestNewChat')
        .catch((e)=>{
          Raven.captureBreadcrumb({
            message: 'Error on new chat',
            category: 'requests',
            data: {
              status: e.response && e.response.status || 'invalid',
              statusText: e.response && e.response.statusText || '',
              responseData: e.response && e.response.data || ''
            }
          });

          Raven.captureException(e)
          this.loading = false
        })
    }

  }
}
</script>
